import { last } from 'lodash';
import core from '@gin-betting/core';

const {
    constants: { ROUTE_DIVIDER },
} = core;

export default function removeLastSlash(route: string) {
    if (last(route) === ROUTE_DIVIDER && route.length > 1) {
        return route.slice(0, -1);
    }

    return route;
}
